import { render, staticRenderFns } from "./FormRadioGroup.vue?vue&type=template&id=721588e4&scoped=true&"
import script from "./FormRadioGroup.vue?vue&type=script&lang=js&"
export * from "./FormRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./FormRadioGroup.vue?vue&type=style&index=0&id=721588e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721588e4",
  null
  
)

export default component.exports